import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take, filter, switchMap } from 'rxjs/operators';
import { selectIsAuthenticated, selectIsAuthInitializing } from '../store/auth/auth.selectors';
import { AUTH_USER_PROPERTY } from '../store/auth/auth.config';

export const guestGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
) => {
  const store = inject(Store);
  const router = inject(Router);
  const userProperty = inject(AUTH_USER_PROPERTY, { optional: true });

  return store.select(selectIsAuthInitializing).pipe(
    filter((initializing) => !initializing),
    take(1),
    switchMap(() => store.select(selectIsAuthenticated)),
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        if (userProperty === 'userAdmin') {
          router.navigate(['/account/residential-developments']);
        } else {
          router.navigate(['/account/dashboard']);
        }
        return false;
      } else {
        return true;
      }
    })
  );
};
